module.exports = __webpack_public_path__ + "img/Infrastructure-2.94a33943.png";